<template>
  <div class="pg_lft_menu" :key="courseId" v-if="permission && permission.version === '5'">

      <b-dropdown no-caret class="navigation-menu" id="courseNavMenu">
        <template slot="button-content">
          <span id="courseNav" class="module_icon ic22-menu3x3">
            <span class="sr-only">course menu</span>
          </span>
        </template>
        <div class="links new_menu">

          <template v-if="isStudentLogin">

            <template v-if="!isOpenCourse || course.lmsCourseId">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'courseDashboard', params: { uuid: course.uuid } }" role="link" aria-label="Course summary dashboard">
                <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('dashboard') }}
                </span>
              </b-dropdown-item>
            </template>

            <template v-if="isOpenCourse">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'courseDetail', params: { uuid: course.uuid } }"  role="link" aria-label="About the course">
                <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('about') }}
                </span>
              </b-dropdown-item>
            </template>

            <template v-if="!isOpenCourse">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" v-if="isContinueLearningReady && continueLearningOptions.length >= 1 && continueLearningOptions[0].title !== 'COURSE_FINISHED'" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, action: 'clickLearn' } }" aria-label="Learn">
                <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('learn') }}
                </span>
                <span class="icon icon-play2"></span>
              </b-dropdown-item>

              <b-dropdown-item class="lnk_menu lnk_menu_footer" v-else :to="{ name: 'courseLearn', params: { uuid: course.uuid } }" aria-label="Learn">
                <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('learn') }}
                </span>
                <span class="icon icon-play2"></span>
              </b-dropdown-item>

              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'myReport', params: { uuid: course.uuid, entityId: course.uuid } }" aria-label="My Reports" v-if="!course.hideScoreForStudent">
                <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('myReports') }}
                </span>
              </b-dropdown-item>
            </template>

            <template v-if="!course.master && sectionChannel">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'courseSectionChannel', params: {uuid: course.uuid, entityId: course.uuid, channelType: 'COURSE'}}" role="link" aria-label="channel">
                <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('channel') }}
                </span>
              </b-dropdown-item>
            </template>

          </template>

          <template v-else-if="isAdvisorViewingReport">
            <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: course.uuid, isShowLearnosityReport: false, isAdvisorViewingReport: isAdvisorViewingReport } }" role="link" aria-label="Reports">
              <!--<span class="ic_container">
                <span class="ic icon-home"></span>
              </span> -->
              <span class="lnk_txt">
                {{ $tf('reports') }}
              </span>
            </b-dropdown-item>
          </template>

          <template v-else>

            <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'courseDashboardInstructor', params: { uuid: course.uuid } }"  role="link" aria-label="Course summary dashboard">
            <!-- <span class="ic_container">
                <span class="ic icon-home"></span>
              </span> -->
              <span class="lnk_txt">
                {{ $tf('dashboard') }}
              </span>
            </b-dropdown-item>

            <template v-if="isEdit">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: (course.master) ? 'courseEdit' : 'courseSectionEdit', params: { uuid: course.uuid } }" role="link" aria-label="About the course">
              <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('about') }}
                </span>
              </b-dropdown-item>
            </template>
            <template v-else>
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'courseDetail', params: { uuid: course.uuid } }" role="link" aria-label="About the course">
              <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('about') }}
                </span>
              </b-dropdown-item>
            </template>

            <template v-if="isCurate">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'courseCuration', params: { uuid: course.uuid } }" role="link" aria-label="Course Content">
              <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('content') }}
                </span>
              </b-dropdown-item>
            </template>
            <template v-else>
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'courseLearn', params: { uuid: course.uuid } }" role="link" aria-label="Course Content">
              <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">
                  {{ $tf('content', 'Content') }}
                </span>
              </b-dropdown-item>
            </template>

            <template v-if="permission.coursePermission.canViewReport">
              <template v-if="!course.master">
                <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: course.uuid, isShowLearnosityReport: false } }" role="link" aria-label="Reports">
                <!-- <span class="ic_container">
                    <span class="ic icon-home"></span>
                  </span> -->
                  <span class="lnk_txt">
                    {{ $tf('reports') }}
                  </span>
                </b-dropdown-item>
              </template>
            </template>

            <template v-if="permission.coursePermission.canViewReport">
              <template v-if="!course.master">
                <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'aggregatedDignosticReport', params: { uuid: course.uuid} }" role="link" aria-label="Reports">
                  <span class="lnk_txt">
                    {{ $tf('diagnosticReports', 'Diagnostic Reports') }}
                  </span>
                </b-dropdown-item>
              </template>
            </template>

            <template v-if="permission.coursePermission.canViewGrading">
        			<template v-if="!course.master">
        				<b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'grading', params: { uuid: course.uuid } }" role="link" aria-label="Grading">
                  <span class="lnk_txt">
                    {{ $tf('grading', 'Grading') }}
                  </span>
                </b-dropdown-item>
        			</template>
            </template>
            <template v-if="!course.master">
                <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'releaseLogic', params: { uuid: course.uuid } }" role="link" aria-label="Release Logic">
                  <span class="lnk_txt">
                    {{ $tf('releaseLogic', 'Release Logic') }}
                  </span>
                </b-dropdown-item>
            </template>

             <template v-if="permission.institutionPermission.canAdminister">
               <b-dropdown-item class="lnk_menu lnk_menu_footer" :disabled="isSandboxUser" :to="{ name: 'enrollmentPage', params: { uuid: course.uuid } }" role="link" aria-label="Admin">
                <!-- <span class="ic_container">
                  <span class="ic icon-home"></span>
                </span> -->
                <span class="lnk_txt">Admin</span>
              </b-dropdown-item>
           	</template>

            <template v-if="!course.master && sectionChannel">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{name: 'courseSectionChannel', params: {uuid: course.uuid, entityId: course.uuid, channelType: 'COURSE'}}" role="link" aria-label="channel">
               <!-- <span class="ic_container">
                 <span class="ic icon-home"></span>
               </span> -->
               <span class="lnk_txt">Channel</span>
             </b-dropdown-item>
            </template>
            <template v-if="course.checkBrokenLinks">
              <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'brokenlinks', params: { uuid: course.uuid } }" role="link" aria-label="Check Broken Links">
                <span class="lnk_txt">Check Broken Links</span>
              </b-dropdown-item>
            </template>

            <!--
            <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'classGrade', params: { uuid: course.uuid } }">
             <span class="ic_container">
               <span class="ic icon-home"></span>
             </span>
             <span class="lnk_txt">Grades</span>
           </b-dropdown-item>
            -->

          </template>

        </div>
      </b-dropdown>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'course-nav-menu',
  props: ['courseId', 'isCurate', 'isEdit', 'isAdvisorViewingReport'],
  data: () => {
    return {
      sectionChannel: null,
      isContinueLearningLoaded: false,
      isContinueLearningReady: false,
      continueLearningType: 'LearningContent',
      continueLearningOptions: [],
      sandboxUsers: ['demoinstructor2@nu.com', 'i1@csu.edu', 'i2@csu.edu', 'i1@vc.edu', 'i2@vc.edu', 'randolph.ward@teachforamerica.org', 'cassandra.zimmer@teachforamerica.org', 'caitlin.ormsby@teachforamerica.org', 'bkransberger@nu.edu', 'i1@lsc.edu', 'i1@pima.edu', 'trinaldi@nu.edu', 'jzavala@nu.edu']
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      if (!this.isContinueLearningReady) {
        this.loadCourse()
      }
    })
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadContinueLearning',
      'loadContinueLearningLast',
      'loadPermission',
      'loadCourseSectionChannel'
    ]),

    async loadCourse () {
      this.sectionChannel = await this.loadCourseSectionChannel(this.courseId)
      if (this.isStudentLogin) {
        this.loadContinueLearningLast({uuid: this.courseId, loadDataFromServer: true}).then((response) => {
          if (response) {
            this.isContinueLearningReady = true
            this.continueLearningOptions = response
          }
        }),
        $('#courseNavMenu .dropdown-menu').attr("aria-labelledby", "courseNavMenu__BV_toggle_");
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'continueLearning': state => state.course.continueLearning,
      'continuLearningLast': state => state.course.continueLearningLast,
      'permission': state => state.user.permission
    }),

    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    },

    isOpenCourse () {
      if (this.course && (this.course.courseType === 'OPEN' || (this.course.courseType && this.course.courseType.includes('EXTERNAL_')))) {
        return true
      }
      return false
    },

    isSandboxUser () {
      var uObj = JSON.parse(localStorage.getItem('userobj'))
      if (uObj) {
        return this.sandboxUsers.includes(uObj.eMail)
      }
      return false
    }
  }

}
</script>
<style scoped>
	.pg_lft_menu {
		display: inline-flex;
		align-items: center;
		float: none;
		width: auto;
		height: 28px;
		padding: 0;
	}

	.pg_lft_menu >>> #courseNavMenu .btn,
	.pg_lft_menu >>> #courseNavMenu button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 28px;
		padding: 0;
		float: none;
		line-height: 1;
	}

	.ic22-menu3x3 {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 28px;
		line-height: 1;
		position: relative;
		top: 2px;
	}
</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseNavMenu.vue